import React, { useState, useEffect } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import CustomTable from "../../organisms/CustomTable";
import Input from "../../atoms/Input";
import CustomDate from "../../atoms/CustomDate";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import UploadDocumentItem from "../DocumnetUploadDialogBox/UploadDocumentItem";
import { ReactComponent as Arrow } from "../../svgs/tableArrow.svg";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { submitCompleteBidDocs } from "../../../utils/API/submitCompleteBidDocs";
import { submitRetirementDoc } from "../../../utils/API/submitRetirementDoc";

const docs = [
  {
    name: "acknowledgment",
    label: "Acknowledgement",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "og_certificate",
    label: "OG Certificate",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "certificate",
    label: "certificate",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "doc_one",
    label: "Document 1",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "doc_two",
    label: "Document 2",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
];

const RetirementPopup = ({
  open,
  onCancel,
  onOk,
  selectedRowData,
  selectedColumns,
  documents,
  setDocuments,
  submitHandler,
  submitLoading,
}) => {
  const dispatch = useDispatch();
  const { register } = useForm();
  const [popUpData, setPopUpData] = useState(null);
  const [uploadedDocuments, setUploadedDocuments] = useState({
    acknowledgment: [],
    og_certificate: [],
    certificate: [],
    doc_one: [],
    doc_two: [],
  });

  useEffect(() => {
    if (selectedRowData && selectedRowData.pop_up_data) {
      setPopUpData(selectedRowData.pop_up_data);
      // console.log(popUpData);
    }
  }, [selectedRowData, selectedColumns, open]);

  let bodyData;
  let headerData;

  if (selectedRowData && selectedColumns) {
    bodyData = [selectedColumns.map((column) => selectedRowData[column])];
    headerData = selectedColumns;
  }

  const organizationName = popUpData?.["Name of Beneficiary Organization"];
  const goal = popUpData?.["Goal"];
  const isStartDate = popUpData?.["Time Period"]?.start_time;
  const isEndDate = popUpData?.["Time Period"]?.end_time;
  const retirementId = popUpData?.["_id"];

  // const organizationName = 5;
  // const goal = 5;
  // const isStartDate = 5/6/4;
  // const isEndDate = 5/8/12;
  // console.log(selectedRowData?.["End Time"]);

  const title = "Time Period";
  const startDate = "From";
  const endDate = "To";

  const handleSubmit = async () => {
    if (
      uploadedDocuments.acknowledgment.length > 0 &&
      uploadedDocuments.og_certificate.length > 0 &&
      uploadedDocuments.certificate.length > 0 &&
      uploadedDocuments.doc_one.length > 0 &&
      uploadedDocuments.doc_two.length > 0
    ) {
      const formData = {
        status: "In-Process",
        documents: {
          acknowledgment: uploadedDocuments.acknowledgment[0].url,
          og_certificate: uploadedDocuments.og_certificate[0].url,
          certificate: uploadedDocuments.certificate[0].url,
          doc_one: uploadedDocuments.doc_one[0].url,
          doc_two: uploadedDocuments.doc_two[0].url,
        },
      };
      const response = await submitRetirementDoc({
        retirementId,
        formData,
        dispatch,
      });
      if (response) {
        // console.log(selectedRowData);
        toast.success("Documents submitted successfully!");
        handleDocumentCancel();
      }
    } else {
      toast.error("Upload all 5 documents to submit data");
    }
  };

  const handleDocumentCancel = () => {
    setUploadedDocuments({
      acknowledgment: [],
      og_certificate: [],
      certificate: [],
      doc_one: [],
      doc_two: [],
    });
    onCancel();
  };

  return (
    <div>
      <DiaglogBox open={open} onCancel={handleDocumentCancel} width={700}>
        <div className="pt-6">
          <div>
            <CustomTable data={bodyData} headerData={headerData} />
          </div>
          <div className="px-8">
            <h4 className="font-medium text-black text-base pt-2">
              Retire credits details from buyer's side
            </h4>
            <Input
              className=" text-xs"
              label="Name of the Beneficiary Organization"
              type="text"
              variant="primary"
              value={organizationName}
              disabled={true}
            />
            <Input
              label="Goal"
              type="text"
              className="pt-3 text-xs"
              variant="primary"
              value={goal}
              disabled={true}
            />
            <div className="pt-3">
              <label className="text-xs  text-gray-400">Time Period</label>
              {isStartDate && isEndDate ? (
                <CustomDate
                  title={title}
                  labelRequired={false}
                  stateName={{
                    startDate: "start_date",
                    endDate: "end_date",
                  }}
                  register={register}
                  startDateLabel={startDate}
                  endDateLabel={endDate}
                  StartDateValue={isStartDate}
                  disabled={true}
                  EndDateValue={isEndDate}
                />
              ) : (
                <p className="text-red-500">Time Period not available</p>
              )}
            </div>
          </div>
        </div>
        <div className="py-4 w-full">
          <div className="px-10">
            <div className="flex  border-b-2">
              <div className="w-[50%] pl-6 flex items-center font-bold">
                <Arrow className="h-2 w-2 mr-1" />
                Documents
              </div>
              <div className="w-[50%] justify-center flex items-center font-bold">
                <Arrow className="h-2 w-2 mr-1" />
                Actions
              </div>
            </div>
            {docs.map(({ label, number, name, allowedFileTypes }) => {
              return (
                <UploadDocumentItem
                  key={name}
                  label={label}
                  number={number}
                  allowedFileTypes={allowedFileTypes}
                  name={name}
                  setDocuments={setUploadedDocuments}
                  uploadList={uploadedDocuments[name]}
                />
              );
            })}
          </div>
          <div className="text-center ">
            <Button
              onClick={handleSubmit}
              variant="primary"
              color="blue"
              className="mt-2 w-36 h-10 mb-2 inline-block text-white text-center text-base font-bold leading-4 mx-2 rounded-md"
            >
              {/* {submitLoading ? <LoadingOutlined /> : "Submit"} */}
              Submit
            </Button>
            <Button
              onClick={handleDocumentCancel}
              variant="primary"
              color="white"
              className="w-36 h-10 mb-2 inline-block text-blue-500 text-center text-base font-bold leading-4 mx-2 border border-solid border-blue-500 rounded-md"
            >
              Cancel
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default RetirementPopup;
